import DeliverabilityAlertsMap from "@/components/deliverability/DeliverabilityAlertsMap";

export default [
  {
    path: "/deliverabilityAlertsMap",
    name: "DeliverabilityAlertsMap",
    component: DeliverabilityAlertsMap,
    meta: {
      requiresAuthentication: true
    }
  }
];
